module.exports = __webpack_public_path__ + "img/only-background.6ffd08b7.svg";